/**
 * Normalizes Get-Material-Summary fields that may be a JSON object, a stringified JSON object,
 * or a legacy plain string (addresses).
 */
export function normalizeMaterialSummaryJsonField(value: unknown): unknown {
    if (value === null || value === undefined) {
        return undefined;
    }
    if (typeof value === 'object' && !Array.isArray(value)) {
        return value;
    }
    if (typeof value === 'string') {
        const trimmed = value.trim();
        if (trimmed === '') {
            return undefined;
        }
        if (trimmed.startsWith('{')) {
            try {
                const parsed: unknown = JSON.parse(trimmed);
                if (parsed !== null && typeof parsed === 'object' && !Array.isArray(parsed)) {
                    return parsed;
                }
            } catch {
                /* treat as legacy string */
            }
            return trimmed;
        }
        return trimmed;
    }
    return undefined;
}
